import { gGateway } from "@utils/gateway";

import { EkeyUserModel, UnicUserModel, UserModel } from "@courses-models/user";

import { AuthenticatedEkeyUserModel, AuthenticatedUnicUserModel } from "@courses-utils/gateway-auth/src/ts/models";

declare global {
    // tslint:disable-next-line interface-name
    interface Window {
        loginConnectorToken: string;
    }
}

/**
 * Helper that'll fetch data about the user that's currently signed in through
 * Gyldendal's LoginConnector (ie. IDP).
 */
export async function authenticateUser(profile: string): Promise<AuthenticatedEkeyUserModel | AuthenticatedUnicUserModel | undefined> {
    const userData = await gGateway.authenticateUser(profile, window.loginConnectorToken);

    // If no LoginConnector token was available, then we know for sure that the
    // user couldn't have been properly authenticated - return null publicly
    if (!userData.loginConnectorToken) {
        return undefined;
    }

    // If we get here, then fetch data about the signed in user, so that we can
    // transform it into an authenticated user model
    let user: UserModel;

    try {
        user = await UserModel.GET_BY_ID(userData.id);
    } catch (err) {
        // tslint:disable-next-line no-console
        console.error(err);

        // Bail out silently, if we were unable to read data about the signed in
        // user!
        return undefined;
    }

    // Transform into an authenticated user model!
    if (user instanceof UnicUserModel) {
        return new AuthenticatedUnicUserModel(user, { profile, token: userData.loginConnectorToken });
    }

    if (user instanceof EkeyUserModel) {
        return new AuthenticatedEkeyUserModel(user, { profile, token: userData.loginConnectorToken });
    }

    // tslint:disable-next-line no-console
    console.warn("authenticateUser(): Unknown user type!", user);

    // If we get here, user type is unknown - bail out!
    return undefined;
}
